<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              v-has-permission="permission210"
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('ProductName') },
                { title: 'تاریخ اخرین به‌روزرسانی موجودی' },
                { title: $t('StockBalance') }
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 55%">
                  {{ row.persianProductName }}
                </td>

                <td style="width: 20%;direction: ltr;">
                  {{ row.dateTimeOfLastCountUpdate }}
                </td>
                <td style="width: 15%">
                  {{ row.count }}
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  name: "saleManagement_Reports_MomentaryInventory_Index",

  components: {
    DataGrid
  },
  data() {
    return {
      permission210: "GetAllSaleAgentQuotaByPageInfo",
      gridDataSource: {
        type: "app",
        service: "Sales/api/QuotaTransactionsQuery/saleAgentQuotas/un-available"
      },
      gridSearchData: {}
    };
  },
  methods: {}
};
</script>
